var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.css(),attrs:{"data-test":"atom-textarea"}},[_c('textarea',_vm._g(_vm._b({class:( _obj = {}, _obj[_vm.css('field')] = true, _obj[_vm.css('field', 'error')] = _vm.error, _obj ),attrs:{"data-test":"textarea"},domProps:{"value":_vm.value}},'textarea',_vm.$attrs,false),_vm.listeners))])}
var staticRenderFns = []

export { render, staticRenderFns }